export default __webpack_public_path__ + "img/8312fe5be67688c13c7b4fe34276843b.svg";